import { GlyphsContainer } from './Glyphs.style';
import type { WhatWeTreatGlyphType } from '../WhatWeTreat';
import { Glyph } from './Glyph';

export const Glyphs = ({ content }: { content: WhatWeTreatGlyphType[] }) => (
  <GlyphsContainer>
    {content.map((glyphContent: WhatWeTreatGlyphType) => (
      <Glyph key={glyphContent.name} content={glyphContent} />
    ))}
  </GlyphsContainer>
);
